import React from "react";
import { useTranslation } from 'react-i18next';
import QuarriesBalikesirWhiteRiver from "../Components/quarries/QuarriesBalikesirWhiteRiver";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";

function BalikesirWhiteRiverPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = {
    title: currentLang === 'tr' ? 'Balıkesir White River Ocağı Mermerleri - MOCA Mermer' : 'Balikesir White River Quarry Marbles - MOCA Marble',
    description: currentLang === 'tr' ? 'Balıkesir White River mermer ocağından çıkarılan White River mermer çeşitleri.' : 'White River marble varieties from Balikesir White River quarry.',
    keywords: currentLang === 'tr' ? 'balıkesir white river ocak, white river mermer, mermer çeşitleri' : 'balikesir white river quarry, white river marble, marble varieties'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/balikesirwhiteriver"
      />
      <TopBar />
      <Spacer />
      <QuarriesBalikesirWhiteRiver />
    </>
  );
}

export default BalikesirWhiteRiverPage;
